import { View, TouchableOpacity } from "react-native"
import { router, useLocalSearchParams } from "expo-router"
import { Image } from "expo-image"
import { useAnalysis } from "@/queries/analysis"
import BackButton from "@/assets/icons/back-arrow-white.svg"
import { useSafeAreaInsets } from "react-native-safe-area-context"
import { useViewedCallback } from "@/analytics/react"
import * as AnalyzerEvents from "@/analytics/events/analyzer"
import { setStatusBarStyle } from "@/stores/statusBarStyle"

import useDeviceAttributes from "@/hooks/useDeviceAttributes"
import BFText from "@/components/standard/BFText"
import { AppleStoreDownloadButton } from "@/components/buttons/AppleStoreDownloadButton"
import { PlayStoreDownloadButton } from "@/components/buttons/PlayStoreDownloadButton"

export default function MapScreen() {
  const { analysisId: paramAnalysisId } = useLocalSearchParams()
  const analysisId = Array.isArray(paramAnalysisId)
    ? paramAnalysisId[0]
    : paramAnalysisId
  const { data: detailedAnalysis } = useAnalysis(analysisId)
  const insets = useSafeAreaInsets()

  const { isLargeScreen } = useDeviceAttributes()

  const analysis = detailedAnalysis?.analysis

  useViewedCallback(() => {
    setStatusBarStyle("light")
    if (analysis) {
      AnalyzerEvents.compMapViewed({
        analysis,
      })
    }
  }, [detailedAnalysis?.analysis])

  if (!analysis) {
    console.log("* NO Analysis -")
    return null // or a loading indicator
  }

  return (
    <View className="relative flex flex-1 bg-midnight-blue">
      <View className="absolute inset-0 size-full">
        <Image
          responsivePolicy="static"
          style={{
            height: "100%",
            width: "100%",
          }}
          contentFit="cover"
          contentPosition={"center"}
          source={[
            {
              uri: isLargeScreen
                ? "https://imagedelivery.net/YGzZH56Oa66tuexCFiV24Q/75fa7525-34ee-47cc-b744-b904d9fed100/width=1920,fit=cover"
                : "https://imagedelivery.net/YGzZH56Oa66tuexCFiV24Q/75fa7525-34ee-47cc-b744-b904d9fed100/width=430,height=932,fit=cover,gravity=0.7x0.5,dpi=3",
            },
          ]}
        />
      </View>
      <View className="flex flex-col flex-1">
        <View
          className="flex justify-end px-6 pb-4"
          style={{ paddingTop: insets.top + 12 }}
        >
          <TouchableOpacity
            testID={"back-button"}
            onPress={() => {
              router.back()
            }}
          >
            <BackButton width={22} height={14} />
          </TouchableOpacity>
        </View>
        <View className="flex flex-col items-center justify-center flex-1 size-full">
          <View className="flex flex-col items-center justify-center flex-1">
            <View className="flex flex-col items-center justify-center shrink-0 w-[250px] ">
              <BFText className="font-figtree-extrabold font-extrabold text-[18px] leading-5 text-center text-white">
                To view map or street view download the app.
              </BFText>
            </View>
            <View className="flex flex-col shrink-0 pt-[50px] gap-5">
              <AppleStoreDownloadButton
                onPress={() => {
                  AnalyzerEvents.compMapPlaceholderAppInstallClicked({
                    analysis,
                    badgeType: "apple_install_badge",
                  })
                }}
              />
              <PlayStoreDownloadButton
                onPress={() => {
                  AnalyzerEvents.compMapPlaceholderAppInstallClicked({
                    analysis,
                    badgeType: "google_install_badge",
                  })
                }}
              />
            </View>
          </View>
        </View>
      </View>
    </View>
  )
}
